import { useCreateMachine } from 'fsm';
import { ObjectTypeDefinitionsContext } from './context';
import { machine } from './machine';
import { jsx as _jsx } from "react/jsx-runtime";
export const ObjectTypeDefinitionsProvider = ({
  children
}) => {
  const objectTypeDefinitionsMachine = useCreateMachine(machine, {
    initialContext: {
      objectTypeDefinitions: []
    }
  });
  return /*#__PURE__*/_jsx(ObjectTypeDefinitionsContext.Provider, {
    value: objectTypeDefinitionsMachine,
    children: children
  });
};